import React from 'react';
import { motion } from 'framer-motion';
import ResumeCard from './ResumeCard';

const Achievements = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <h2 className="text-3xl md:text-4xl font-bold"> internship experience</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          {/* Wells Fargo Software Engineering Job Simulation */}
          <ResumeCard
            title="Wells Fargo Backend"
            // subTitle="Forage "
            result="Remote"
            des={
              <ul className="list-disc ml-5">
                <li>
                  Successfully designed and implemented an entity relationship diagram (ERD) that
                  effectively mapped financial data requirements.
                </li>
                <li>
                  Contributed to a prototype for a financial portfolio management system that
                  addressed real-world use cases.
                </li>
                <li>
                  Published my work on GitHub, enhancing collaboration and version control skills
                  within a team environment.
                </li>
              </ul>
            }
          />
          {/* Lyft Back-End Engineering Job Simulation */}
          <ResumeCard
            title="Lyft Back-End dev"
            // subTitle="Forage -"
            result="Remote"
            des={
              <ul className="list-disc ml-5">
                <li>
                  Revamped an incomplete project by implementing a new UML class diagram, improving
                  system architecture and code organization.
                </li>
                <li>
                  Increased code efficiency and readability through refactoring, resulting in a more
                  maintainable codebase.
                </li>
                <li>
                  Developed unit tests that enhanced the reliability of the code and ensured
                  adherence to quality standards.
                </li>
              </ul>
            }
          />
          {/* Skyscanner Front-End Software Engineering Virtual Experience */}
          <ResumeCard
            title="Skyscanner Front-End Software Engineering Virtual Experience"
            // subTitle="Forage - August 2023"
            result="Remote"
            des={
              <ul className="list-disc ml-5">
                <li>
                  Created an interactive web application feature for selecting travel dates,
                  enhancing user experience with responsive design.
                </li>
                <li>
                  Applied knowledge of the Backpack React library to produce a visually appealing
                  and functional UI component.
                </li>
                <li>
                  Ensured application stability and performance through comprehensive automated
                  testing, leading to higher user satisfaction.
                </li>
              </ul>
            }
          />
          {/* Business Analyst Role at Rentalsify */}
          <ResumeCard
            title="Business Analyst"
            // subTitle="Rentalsify - March 2023 to May 2023"
            result="Remote"
            des={
              <ul className="list-disc ml-5">
                <li>
                  Developed user stories that directly informed product features, improving user
                  engagement and project outcomes.
                </li>
                <li>
                  Created compelling data visualizations that assisted in presenting key insights to
                  stakeholders, enhancing decision-making processes.
                </li>
                <li>
                  Conducted competitive analysis that led to strategic recommendations, positively
                  impacting the company’s market positioning.
                </li>
              </ul>
            }
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Achievements;
